module.exports = __webpack_public_path__ + "static/media/next-page.7068a0e2.svg";